var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1684 6.83175L9.24794 12.3308L0.963562 9.56901C0.385298 9.37587 -0.00428255 8.83332 -0.000955416 8.2238C0.00241549 7.61428 0.396462 7.07507 0.976958 6.88866L22.1573 0.0678226C22.6607 -0.0940248 23.2134 0.0387978 23.5874 0.412794C23.9613 0.786789 24.0942 1.33936 23.9323 1.84285L17.1114 23.0231C16.925 23.6036 16.3858 23.9977 15.7763 24.0011C15.1668 24.0044 14.6242 23.6148 14.4311 23.0365L11.6559 14.712L17.1684 6.83175Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLogo);
export default __webpack_public_path__ + "static/media/send-logo.f81538639167899169239c0865de85dd.svg";
export { ForwardRef as ReactComponent };